export default __webpack_public_path__ + "static/media/currency.8ed57fd9.svg";